// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 路由
import router from './router';

import FastClick from 'fastclick';
// 解决移动端点击延迟
FastClick.attach(document.body);

// 使用插件iscroll
import VueScroll from 'vue-infinite-scroll';
Vue.use(VueScroll);

// 路由封装
import GlobalConstant from './util/GlobalConstant';
GlobalConstant.router = router.router();

// 引入注册组件配置
import ComponentConfig from './config/ComponentConfig';
ComponentConfig.createComponent(Vue);
// 引入定位配置
// import LocationConfig from './config/LocationConfig';

// 引入网络配置
import NetworkConfig from './config/NetworkConfig';

// 引入vue的原型配置
import PrototypeConfig from './config/PrototypeConfig';
PrototypeConfig.createPrototype(Vue);

Vue.config.productionTip = false;

// 全局变量引入
import StoreConfig from './config/StoreConfig';
/* eslint-disable no-new */
new Vue({
  render:h => h(App),
  // router,开始数据勿动
  router: GlobalConstant.router,
  store: StoreConfig.initStore(),
  // template: '<App/>',
  // components: { App },
  created() {
    // 网络请求初始化
    NetworkConfig.createNetwork(this);
  },
  methods:{
    // helpDoesNotOpenPosition(){
    //   let helpPosition = window.location.href;
    //   let activityLocation = null;
    //   let regList = [/mineOrder/, /mineTransshipment/, /mineOrderDetail/, /tradePayment/];
    //   for (let i = 0; i < regList.length; i++){
    //     if (regList[i].test(helpPosition)){
    //       activityLocation = true;
    //       break;
    //     } else {
    //       activityLocation = false;
    //     }
    //   }
    //   if (!activityLocation && activityLocation !== null){
    //     LocationConfig.appPickLocation().then((data) => {
    //     }, (error) => {
    //       console.log(error);
    //     });
    //   }
    // }
  },
  mounted() {
    // this.helpDoesNotOpenPosition();
    // 定位初始化
    document.addEventListener('DOMContentLoaded', function (e) {
      // xrem => ypx       x*100/2 = y
      // xpx => yrem       x*2/100 = y
      document.getElementsByTagName('html')[0].style.fontSize = window.innerWidth * 2 / 15 + 'px';
        if (window.innerWidth <= 800){
          console.log(window.innerWidth)
          document.getElementsByTagName('html')[0].style.fontSize = window.innerWidth * 2 / 15 + 'px';
        }
    }, false);
  }
}).$mount('#app');
